import React, { memo } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import Indicator from 'design-system/Indicator';
import Links from 'utils/links';
const AboutInfoRow = ({ info, title, requesting, isLink = false, tableSpacing = false, descNumberOfLines = 1, noPaddingHorizontal = false, }) => {
    const onLinkPress = () => {
        if (info) {
            Links.openLink(String(info));
        }
    };
    const renderInfo = () => {
        if (isLink && info) {
            return (<TouchableOpacity onPress={onLinkPress}>
          <Text {...(tableSpacing ? { 'Text-14': true } : { 'Text-16': true })} Primary numberOfLines={1}>
            {info}
          </Text>
        </TouchableOpacity>);
        }
        return (<Text {...(tableSpacing ? { 'Text-14': true } : { 'Text-16': true })} numberOfLines={descNumberOfLines} style={styles.desc}>
        {info || '-'}
      </Text>);
    };
    return (<View style={[styles.container, tableSpacing && styles.tableSpacing, noPaddingHorizontal && styles.noPaddingHorizontal]}>
      {typeof title === 'string' ? (<Text {...(tableSpacing ? { 'TextThin-14': true } : { 'TextThin-16': true })} Gray>
          {title}
        </Text>) : (title)}
      <Spacer w={16}/>
      <View style={styles.infoContainer}>{requesting ? <Indicator dark/> : renderInfo()}</View>
    </View>);
};
export default memo(AboutInfoRow);
const styles = StyleSheet.create({
    container: {
        paddingVertical: rem(16),
        paddingHorizontal: rem(16),
        alignItems: 'center',
        flexDirection: 'row',
    },
    tableSpacing: {
        paddingVertical: rem(12),
    },
    desc: {
        textAlign: 'right',
    },
    infoContainer: {
        flex: 1,
        alignItems: 'flex-end',
    },
    noPaddingHorizontal: {
        paddingHorizontal: 0,
    },
});
